import request from "@/utils/request";
import { ADMIN_SERVICE_URL } from "@/utils/constant";

export function getDict(params) {
  return request({
    url: `${ADMIN_SERVICE_URL}/dictionaries/getdict`,
    type: "get",
    params
  });
}
